<!--suppress AngularNgOptimizedImage, JSUnresolvedReference -->
<div class="d-flex w-100 align-items-center justify-content-center flex-column">
  <div class="logo">
    <img src="assets/logos/logo-full.svg" alt="logo" />
  </div>
  @if (luser | async; as user) {
    <div class="welcome">
      <span class="fw-lighter text-secondary" i18n>Welcome</span
      ><span class="fw-light text-primary">
        @if (user.lastname || user.firstname) {
          {{ user.lastname }} {{ user.firstname }}
        } @else {
          {{ user.email }}
        }
      </span>
    </div>
    <div class="no-role my-2">
      You currently have no role assigned to your account. Please notify the
      Administrator.
    </div>
  }
</div>
